module.exports = __webpack_public_path__ + "img/transformacao-digital-thumb.72469759.jpg";